import Tooltip from '@material-ui/core/Tooltip/index';
import React from 'react';
import Zoom from '@material-ui/core/Zoom/index';
import {
  IconButton, Theme, WithStyles, withStyles,
} from '@material-ui/core';
import createStyles from '@material-ui/core/styles/createStyles';

const styles = (theme: Theme) => createStyles({
  button: {
    margin: theme.spacing(0.5),
    '& svg': {
      color: theme.palette.type === 'dark' ? theme.palette.text.primary : theme.palette.text.secondary,
    },
  },
});

interface Props extends WithStyles<typeof styles> {
  label: string,
  icon: JSX.Element,
  onClick: (e: React.MouseEvent<HTMLElement>) => void,
  disabled: boolean
}

const ToolboxButton = (props: Props) => {
  const {
    classes, label, icon, onClick, disabled,
  } = props;
  return disabled ? (
    <IconButton
      color="inherit"
      onClick={onClick}
      classes={{ colorInherit: classes.button }}
      disabled
    >
      {icon}
    </IconButton>
  ) : (
    <Tooltip
      title={label}
      placement="right"
      TransitionComponent={Zoom}
      enterDelay={300}
      TransitionProps={{ timeout: 100 }}
    >
      <IconButton color="inherit" onClick={onClick} classes={{ colorInherit: classes.button }}>
        {icon}
      </IconButton>
    </Tooltip>
  );
};

export default withStyles(styles)(ToolboxButton);
